import { render, staticRenderFns } from "./JsonDiff.vue?vue&type=template&id=5c82fb23&scoped=true&"
import script from "./JsonDiff.vue?vue&type=script&lang=js&"
export * from "./JsonDiff.vue?vue&type=script&lang=js&"
import style0 from "./JsonDiff.vue?vue&type=style&index=0&id=5c82fb23&prod&scoped=true&lang=scss&"
import style1 from "./JsonDiff.vue?vue&type=style&index=1&id=5c82fb23&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c82fb23",
  null
  
)

export default component.exports